/** Deep links from Settings → Campaign to edit each entity. */

export const SETTINGS_SEARCH_PARAMS = {
  openRecruitingProfile: "open_recruiting_profile",
}

export const MY_MLS_SEARCH_PARAMS = {
  openLeadTargeting: "open_lead_targeting",
  openMlsPurchase: "open_mls_purchase",
}

const SETTINGS_PROFILE_TAB = "profile"

/** Profile tab with recruiting campaign profile dialog auto-open. */
export function recruitingProfileEditPath() {
  const params = new URLSearchParams({
    tab: SETTINGS_PROFILE_TAB,
    [SETTINGS_SEARCH_PARAMS.openRecruitingProfile]: "1",
  })
  return `/settings/?${params.toString()}`
}

/** My MLS page with Lead Targeting for Campaign dialog auto-open. */
export function leadTargetingEditPath() {
  const params = new URLSearchParams({
    [MY_MLS_SEARCH_PARAMS.openLeadTargeting]: "1",
  })
  return `/leads/?${params.toString()}`
}

/** My MLS page with Purchase MLS dialog auto-open. */
export function mlsPurchasePath() {
  const params = new URLSearchParams({
    [MY_MLS_SEARCH_PARAMS.openMlsPurchase]: "1",
  })
  return `/leads/?${params.toString()}`
}
